import type { InventoryIdQueryParams } from "../InventoryIdQueryParams"
import type { ApiRoute, NoPathParams } from "../api"
import type { EquipmentChange } from "./EquipmentChange"
import type { DetailsEquipmentView } from "./details/DetailsEquipmentStageView"

export const changeEquipmentRoute: ApiRoute<
	NoPathParams,
	InventoryIdQueryParams,
	EquipmentChange,
	DetailsEquipmentView
> = {
	buildUrl: () => "/equipment/_change",
	method: "post",
	path: "/equipment/_change",
}
